<template>
  <!-- Campaign delete modal (soft delete: status deleted, скрываем из списка) -->
  <div v-if="showCampaignConfirm" class="modal-backdrop" role="dialog" aria-modal="true">
    <div class="modal">
      <div class="modal__title">Удалить кампанию?</div>
      <div class="modal__body">
        Кампания будет скрыта из списка. В базе данных она сохранится со статусом «удалена».
      </div>
      <div class="modal__actions">
        <button class="btn" @click="$emit('cancel-modal')">Отмена</button>
        <button class="btn btn--danger" @click="$emit('confirm-cancel')">Удалить</button>
      </div>
    </div>
  </div>

  <!-- Ad cancel modal -->
  <div v-if="showAdConfirm" class="modal-backdrop" role="dialog" aria-modal="true">
    <div class="modal">
      <div class="modal__title">Отменить объявление?</div>
      <div class="modal__body">
        Это действие безвозвратно. Объявление будет отправлено на отмену.
      </div>
      <div class="modal__actions">
        <button class="btn" @click="$emit('cancel-ad-modal')">Отмена</button>
        <button class="btn btn--danger" @click="$emit('confirm-ad-cancel')">Отменить объявление</button>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'CampaignModals',
  props: {
    showCampaignConfirm: {
      type: Boolean,
      required: true
    },
    showAdConfirm: {
      type: Boolean,
      required: true
    }
  },
  emits: ['cancel-modal', 'confirm-cancel', 'cancel-ad-modal', 'confirm-ad-cancel']
}
</script>
